export function hasFlag(composit: number, flag: number): boolean {
    // eslint-disable-next-line no-bitwise
    return (composit & flag) === flag;
}
